import { STATUS_TYPE } from '@/enums/sites/status.enum';
import { rules } from './useMountCardStatus.rules';
import { ThemeContext } from 'styled-components';
import { useCallback, useContext } from 'react';

const useMountCardStatus = () => {
  const theme = useContext(ThemeContext);
  const getAllSiteStatus = useCallback(siteItem => ({
    pending: siteItem.status.toLowerCase() === 'pending',
    inAnalysis: siteItem.sub_status.toLowerCase() === 'in_analysis',
    planIsToDue: siteItem.sub_status.toLowerCase() === 'to_due',
    planIsOverdue: siteItem.sub_status.toLowerCase() === 'overdue',
    planSuspended: siteItem.status.toLowerCase() === 'suspended',
  }), []);

  const mountWarningStatus = useCallback((allSiteStatus) => {
    if (allSiteStatus.domainSuspended || allSiteStatus.planSuspended) return STATUS_TYPE.SUSPENDED;
    if (allSiteStatus.planIsOverdue || allSiteStatus.domainIsOverdue) return STATUS_TYPE.OVERDUE;
    if (allSiteStatus.domainIsToDue || allSiteStatus.planIsToDue) return STATUS_TYPE.TODUE;
    if (allSiteStatus.inAnalysis) return STATUS_TYPE.ANALYSIS;
    if (allSiteStatus.pending) return STATUS_TYPE.PENDING;
    return STATUS_TYPE.ACTIVE;
  }, []);

  const getSiteStatus = useCallback((siteItem) => {
    const allSiteStatus = getAllSiteStatus(siteItem);
    return mountWarningStatus(allSiteStatus);
  }, [getAllSiteStatus, mountWarningStatus]);

  const validatePlanDomainState = useCallback((siteItem) => {
    const allSiteStatus = getAllSiteStatus(siteItem);
    const warningStatus = mountWarningStatus(allSiteStatus);
    return rules[warningStatus](theme, siteItem, allSiteStatus);
  }, [getAllSiteStatus, mountWarningStatus, theme]);

  const mountCardStatusData = {
    validatePlanDomainState,
    getAllSiteStatus,
    getSiteStatus,
    mountWarningStatus,
  };
  return mountCardStatusData;
};

export default useMountCardStatus;
